module.exports = __webpack_public_path__ + "static/media/mega_new.a4c4ffc0.mp3";